import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";

import { portalRoutes } from "@/router/routes/portalRoutes.ts";
import { isAnonymousUserAtom } from "@/utils/atoms.ts";

export const usePortalHomeLink = (): string | undefined => {
  const { pathname } = useLocation();
  const isAnonymousUser = useAtomValue(isAnonymousUserAtom);

  if (isAnonymousUser) {
    return undefined;
  }

  const isProfileCompletionRoute =
    pathname === portalRoutes.initialPasswordSetup ||
    pathname === portalRoutes.personalDataOnboarding;

  if (isProfileCompletionRoute) {
    return undefined;
  }

  return portalRoutes.cockpit.base;
};
